import React from 'react';
import { useNotifications } from './hooks/useNotifications';
import { useReportState } from './hooks/useReportState';
import { useReportFilters } from './hooks/useReportFilters';
import { useReportData } from './hooks/useReportData';
import { useReportActions } from './hooks/useReportActions';
import ReportHeader from './components/ReportHeader';
import ReportFilters from './components/ReportFilters';
import ReportTable from './components/ReportTable';
import ConfirmDialog from '../ConfirmDialog';
import ReportPagination from './components/ReportPagination';

const TreatmentReportList = ({ 
  onReportSelect, 
  onAddReport, 
  onEditReport,
  currentUser, 
  userProfile 
}) => {
  // Initialize hooks
  const notifications = useNotifications();
  const reportState = useReportState();
  const filters = useReportFilters();
  
  // Data management
  const dataHelpers = useReportData(userProfile, reportState, filters, notifications);
  const actions = useReportActions(userProfile, notifications, dataHelpers);

  // Loading guard
  if (!userProfile) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-6">
      {/* Header */}
      <ReportHeader onAddReport={onAddReport} />

      {/* Search and Filters */}
      <ReportFilters 
        filters={filters}
        technicians={reportState.technicians}
        onSearchChange={filters.setSearchTerm}
        onStatusChange={filters.setStatusFilter}
        onTechnicianChange={filters.setTechnicianFilter}
      />

      {/* Reports Table */}
      <ReportTable 
        reports={reportState.reports}
        isLoading={reportState.isLoading}
        filters={filters}
        onReportSelect={onReportSelect}
        onEditReport={onEditReport}
        onAddReport={onAddReport}
        onDeleteReport={actions.handleDeleteReport}
        onGeneratePDF={actions.handleGeneratePDF}
      />

      {/* Pagination */}
      <ReportPagination
        pagination={reportState.pagination}
        onPageChange={dataHelpers.handlePageChange}
      />

      {actions.confirmDialog && <ConfirmDialog {...actions.confirmDialog} />}
    </div>
  );
};

export default TreatmentReportList;